module.exports = __webpack_public_path__ + "img/empty-coupons.6e1db181.svg";